<template>
  <div :class="['cdu-events-component']">

    <!-- SINGLE EVENT TEMPLATE -->
    <div v-if="screenConfiguration.is2showsingleevent" class="single-event">
      <div
        :class="['event', event.idfosporttype.replace(/ /g, ''), event.sportname.replace(/ /g, ''),
            { prematch: !event.isliveevent && event.idfobolifestate === 'O' },
            { resulted: event.idfobolifestate !== 'O' },
            { live: event.isliveevent && event.idfobolifestate === 'O' }]" v-for="event in cduSingleEvents">

        <div class="event-info-head">
          <cdu-info-head :event="event"></cdu-info-head>
        </div>

        <div class="markets-columns two-columns">
          <div class="column" v-for="column in cduSingleEventsNumberOfColumns">
            <!-- Big3 Coupon -->
            <div
              v-if="column === 0 &&
                  ((['SOCCER', 'TENNIS', 'BOXING', 'MMA'].indexOf(event.idfosporttype) === -1 && hasBig3Markets(event)) ||
                  (['SOCCER', 'TENNIS', 'BOXING', 'MMA'].indexOf(event.idfosporttype) > -1 && hasMoneylineMarkets(event))) ||
                  brand_ultrawide"
              class="event">

              <live-event v-if="event.isliveevent && event.idfobolifestate === 'O'"
              :event="event"
              :showheader="true"></live-event>

              <simple-event v-if="!event.isliveevent || event.idfobolifestate !== 'O'"
              :event="event"
              :showheader="true"></simple-event>
            </div>

            <!-- Other markets -->
            <div class="single-event-markets" v-if="!(cduState === '2column-single-stats' && appConfigForBrand.showParticipantStats &&  screenConfiguration.is2showstats)">
              <markets v-if="cduSingleEventMarketsByPage(event).filter(mk => {return singleEventOthersMarketsFilter(mk, column)}).length > 0"
                       class="markets-container"
                       :event="event"
                       :markets="cduSingleEventMarketsByPage(event).filter(mk => {return singleEventOthersMarketsFilter(mk, column)})"
                       :is2displayhorizontally="false"
                       :forcenonbig3="true">
              </markets>
            </div>
            <event-stats
              :event="event"
              v-if="((cduState === '2column-single-stats') ||
              (column === 1 && cduState === 'single-stats')) &&
              appConfigForBrand.showParticipantStats &&
              screenConfiguration.is2showstats">
            </event-stats>
          </div>
        </div>
      </div>
    </div>

    <!-- OUTRIGHT template -->
    <div v-else-if="screenConfiguration.is2showoutrightevents" class="no-columns">
      <template v-if="screenConfiguration.is2showoutrightevents">
        <div class="events non-pinned clearfix">
          <div v-if="event" v-for="event in cduOutrightEvents" :key="event.idfoevent"
            :class="['event', 'outright', event && event.idfosporttype,
            { 'with-header': true },
            { prematch: !event.isliveevent && event.idfobolifestate === 'O' },
            { live: event.isliveevent && event.idfobolifestate === 'O' }]">
            <outright-event :event="event" :showheader="true"></outright-event>
          </div>
        </div>
      </template>
    </div>

    <!-- TWO COLUMN BIG3 TEMPLATE -->
    <div v-else-if="screenConfiguration.is2showeventsin2columns" :class="[ 'two-columns', { 'all-events-same-sporttype': eventsPerColumn[1].length === 7 }]">
      <div class="column" v-for="column in [1, 2]">
        <div v-if="isDebug" class="debug">
          {{ eventsPerColumn[column].map(ev => ev.eventrows) }} {{ eventsPerColumn[column].map(ev => ev.eventrows).reduce((a, b) => a + b, 0) }}
        </div>

        <template v-if="!group2ColumnEventsBy || group2ColumnEventsBy === 'DEFAULT'">
          <div
            :class="['event', event.idfosporttype.replace(/ /g, ''), event.sportname.replace(/ /g, ''),
            { 'with-header': event.showeventheader || index === 0 },
            { 'no-header': !event.showeventheader && index !== 0 },
            { 'odd': isOdds[column][event.idfoevent] },
            { resulted: event.idfobolifestate !== 'O' },
            { prematch: !event.isliveevent && event.idfobolifestate === 'O' },
            { live: event.isliveevent && event.idfobolifestate === 'O' },
            { 'no-markets': !event.markets || event.markets.length === 0 },
            { outright: event.isoutright}]" v-for="(event, index) in eventsPerColumn[column]">

            <live-event v-if="event.isliveevent && event.idfobolifestate === 'O'"
                        :event="event"
                        :showheader="event.showeventheader || index === 0"></live-event>

            <simple-event v-if="!event.isliveevent || event.idfobolifestate !== 'O'"
                          :event="event"
                          :showheader="event.showeventheader || index === 0"></simple-event>
          </div>
        </template>
        <template v-if="group2ColumnEventsBy === 'DATE'">
          <template v-for="date in eventsPerColumnGroupedByDate[column]">
            <div
              :class="['event', event.idfosporttype.replace(/ /g, ''), event.sportname.replace(/ /g, ''),
                { 'with-header': index === 0 },
                { 'no-header': index !== 0 },
                { resulted: event.idfobolifestate !== 'O' },
                { prematch: !event.isliveevent && event.idfobolifestate === 'O' },
                { live: event.isliveevent && event.idfobolifestate === 'O' },
                { 'no-markets': !event.markets || event.markets.length === 0 },
                { 'stats-highlight': (event.idfoevent === cduNonPinnedEventsPaged[currentStatsIndex].idfoevent) && appConfigForBrand.showParticipantStats &&  screenConfiguration.is2showstats},
                { outright: event.isoutright}]" v-for="(event, index) in date">

              <live-event v-if="event.isliveevent && event.idfobolifestate === 'O'"
                          :event="event"
                          :showheader="index === 0"
                          :headertype="group2ColumnEventsBy"></live-event>

              <simple-event v-if="!event.isliveevent || event.idfobolifestate !== 'O'"
                            :event="event"
                            :showheader="index === 0"
                            :headertype="group2ColumnEventsBy"></simple-event>
            </div>
          </template>
        </template>

        <event-stats
          :event="cduNonPinnedEventsPaged[currentStatsIndex]"
          v-if="column === 2 &&
          appConfigForBrand.showParticipantStats &&
          screenConfiguration.is2showstats">
        </event-stats>
      </div>
    </div>

    <!-- NO COLUMNS TEMPLATE -->
    <div v-else class="no-columns">
      <!-- STANDARD template -->
      <template>
        <div class="events pinned">
          <div :class="['event', event.idfosporttype.replace(/ /g, ''), event.sportname.replace(/ /g, ''),
            { 'with-header': true },
            { resulted: event.idfobolifestate !== 'O' },
            { prematch: !event.isliveevent && event.idfobolifestate === 'O' },
            { outright: event.isoutright},
            { live: event.isliveevent && event.idfobolifestate === 'O' }]" v-for="event in cduPinnedEvents">
            <live-event v-if="event.isliveevent && event.idfobolifestate === 'O'" :event="event" :showheader="true"></live-event>
            <simple-event v-if="!event.isliveevent || event.idfobolifestate !== 'O'" :event="event" :showheader="true"></simple-event>
          </div>
        </div>

        <div class="events non-pinned clearfix">
          <div :class="['event', event.idfosporttype.replace(/ /g, ''), event.sportname.replace(/ /g, ''),
            { 'with-header': true },
            { resulted: event.idfobolifestate !== 'O' },
            { prematch: !event.isliveevent && event.idfobolifestate === 'O' },
            { outright: event.isoutright},
            { live: event.isliveevent && event.idfobolifestate === 'O' }]" v-for="event in cduNonPinnedEventsPaged">
            <live-event v-if="event.isliveevent && event.idfobolifestate === 'O'" :event="event" :showheader="true"></live-event>
            <simple-event v-if="!event.isliveevent || event.idfobolifestate !== 'O'" :event="event" :showheader="true"></simple-event>
          </div>
        </div>
      </template>
      </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import store from '@/store'
  import lib from '@/library'

  import Brands from '@/components/mixins/Brands'
  import Rotate from '@/components/mixins/Rotate'
  import Screen from '@/components/mixins/Screen'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import SingleEvent from '@/components/mixins/templates/SingleEvent'

  import LiveEvent from '@/components/bettingoffer/live/liveEvent'
  import OutrightEvent from '@/components/bettingoffer/outrightEvent'
  import SimpleEvent from '@/components/bettingoffer/simpleEvent'
  import markets from '@/components/bettingoffer/markets'
  import CduInfoHead from '@/components/cdu/cduInfoHead'
  import EventStats from '@/components/cdu/EventStats'

  export default {
    name: 'CduEvents',

    mixins: [
      Brands,
      Rotate,
      Screen,
      SingleEvent,
      BettingOffer
    ],

    components: {
      LiveEvent,
      OutrightEvent,
      SimpleEvent,
      EventStats,
      CduInfoHead,
      markets
    },

    data () {
      return {
        noHeaderIndex: 0
      }
    },

    computed: {
      cduState () {
        return store.getters['cduState/getScreenState']
      },
      cduPinnedEvents () {
        return store.getters['bettingOfferState/getCduPinnedEvents']
      },
      cduNonPinnedEvents () {
        return store.getters['bettingOfferState/getCduNonPinnedEvents']
      },
      cduOutrightEvents () {
        return store.getters['bettingOfferState/getCduOutrightEvents']
      },

      cduSingleEventsNumberOfColumns () {
        return lib.cdu.config.isHalfTemplate() ? [0] : [0, 1]
      },
      cduNonPinnedEventsPaged () {
        return this.cduNonPinnedEvents.filter(ev => ev.eventPage === this.currentRotateIndex)
      },
      cduOneColumnEvents () {
        return this.cduPinnedEvents.concat(this.cduNonPinnedEventsPaged)
      },
      eventsPerColumn () {
        return {
          1: this.cduNonPinnedEventsPaged.filter(ev => ev.displaycol === 1),
          2: this.cduNonPinnedEventsPaged.filter(ev => ev.displaycol === 2)
        }
      },
      eventsPerColumnGroupedByDate () {
        var col1Events = this.cduNonPinnedEventsPaged.filter(ev => ev.displaycol === 1)
        var col2Events = this.cduNonPinnedEventsPaged.filter(ev => ev.displaycol === 2)

        var col1EventsGroupedByDate = col1Events && col1Events.length > 0 ? Vue._.groupBy(col1Events, 'tsDate') : []
        var col2EventsGroupedByDate = col2Events && col2Events.length > 0 ? Vue._.groupBy(col2Events, 'tsDate') : []

        return {
          1: col1EventsGroupedByDate,
          2: col2EventsGroupedByDate
        }
      },
      isOdds () {
        var isOdds = {}
        var columns = [1, 2]
        columns.forEach(column => {
          var noHeaderIndex = 0
          isOdds[column] = {}
          this.eventsPerColumn[column].forEach((evt, index) => {
            var odd = true
            if (index === 0 || evt.showeventheader) {
              noHeaderIndex = 0
            }
            odd = noHeaderIndex % 2
            noHeaderIndex++

            isOdds[column][evt.idfoevent] = odd
          })
        })

        return isOdds
      },
      appConfigForBrand () {
        return store.getters['cduState/getAppConfigForBrand'] || {}
      },
      group2ColumnEventsBy () {
        return this.appConfigForBrand.group2ColumnEventsBy
      },
      isEventLivePerIdfoevent () {

      }
    },

    methods: {
      cduSingleEventMarketsByPage (event) {
        if (event && event.markets && event.marketsByPages) {
          var currentRotateIndex = this.currentRotateIndex

          if (lib.cdu.config.isHalfTemplate()) {
            currentRotateIndex = event.half === 0 ? this.currentRotateIndex : this.currentRotateIndex1
          }

          var group = event.marketsByPages.filter(group => group.page === currentRotateIndex)
          return group[0] && group[0].markets ? group[0].markets : []
        } else {
          return []
        }
      },
      singleEventOthersMarketsFilter (market, column) {
        var popular = market.isPopular

        return !popular && market.currentColumn === column
      },
      isBig3Market (market) {
        return lib.betting.market.isBig3Market(market)
      },

      hasBig3Markets (event) {
        return lib.betting.event.hasBig3Markets(event)
      },

      hasMoneylineMarkets (event) {
        return lib.betting.event.hasMoneyline(event)
      }
    },

    mounted () {

    },

    watch: {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  @import '~@/css/config'

  .event
    > div
      height: 100%

    >>> table
      margin: 0
      height: 100%

    >>> .name
      font-weight: 700
      font-size: 1.4rem
      // width: 91%

    >>> .listcode
      text-align: center
      font-size: 1.2rem

    >>> .final-result
      white-space: nowrap

    >>> .score
    >>> .period
    >>> .final-result
    >>> .halftime
      text-align: center

    >>> th.score
    >>> th.period
    >>> th.final-result
    >>> th.halftime
      border-left: solid 1px #000

    >>> .score
      font-size: 1.5rem
      width: 60px
      min-width: 43px
      padding: 0

    >>> .footer
      td
        background: #ececec

    tr
      height 32px

    &.prematch
      width 100%
      clear both

      table
        width: 30%

    &.resulted
      width unit(event-info-width, px)
      float left
      margin-right 30px

    &.live
      width 100%
      clear both

      table
        width 30%
</style>



// WEBPACK FOOTER //
// src/components/cdu/cduEvents.vue